/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/11/22, 3:21 PM
 *
 */

import { useQuery } from 'react-query';

import { listTests } from 'features/members/api/requests/test.request';

export const useTestList = () => {
  return useQuery('test-lists-category', () => listTests(), {});
};
